import React from "react";
import logo from "../images/rrlogoicon.png";
import { FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { motion } from "framer-motion";

const Footer = () => {
  return (
    <div className="flex w-[80%] flex-col justify-center mx-auto">
      <div className="h-[1px] w-full rounded-sm bg-bigblue opacity-50 mb-4"></div>
      <div className="flex md:flex-nowrap md:flex-row flex-col justify-center items-center mx-auto">
        <div className="flex flex-col items-center justify-center">
          <div
            className="flex gap-4 align-middle justify-center"
            title="Coded with 💛 by Luke Muehring"
          >
            <img
              className="w-[50px] h-[50px] self-center"
              src={logo}
              alt="our logo"
            ></img>
            <p className="flex gap-2 flex-col md:flex-row text-3xl text-bigblue w-min self-center">
              <span className="whitespace-nowrap"> Rest & Relax</span>
              <span className="whitespace-nowrap"> Vacation LLC </span>
            </p>
          </div>
        </div>
        {/* BUTTONS */}
        <div className="flex md:flex-nowrap justify-center items-center my-2">
          <motion.button
            whileHover={{
              scale: 1.2,
              transition: { duration: 0.2 },
            }}
            whileTap={{ rotate: 10, scale: 0.9, transition: 0.05 }}
          >
            <a
              href="https://www.instagram.com/restandrelaxvacation/"
              target="_blank"
            >
              <FaInstagram className="text-bigblue h-[30px] w-[30px] mx-4" />
            </a>
          </motion.button>
          <motion.button
            whileHover={{
              scale: 1.2,
              transition: { duration: 0.2 },
            }}
            whileTap={{ rotate: 10, scale: 0.9, transition: 0.05 }}
          >
            <a
              href="https://www.youtube.com/@veronicamuehring9617/videos"
              target="_blank"
            >
              <FaYoutube className="text-bigblue h-[30px] w-[30px]" />
            </a>
          </motion.button>
        </div>
      </div>
    </div>
  );
};

export default Footer;
